export default __webpack_public_path__ + "static/media/emoji_group.59a73f57.svg";